import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TwoFAFillIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TwoFAFill",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.09 7.9 16.44 2.12C16.31 2.05 16.16 2 16 2s-.31.04-.44.12L4.91 7.9c-.28.16-.47.46-.47.8 0 6.94 1.44 11.43 3.59 14.6s4.96 4.94 7.47 6.55c.14.1.31.15.49.15s.36-.06.5-.15c2.52-1.61 5.33-3.36 7.48-6.55s3.59-7.66 3.59-14.59c0-.34-.19-.64-.47-.8Zm-4.8 5.47-7.22 7.21c-.25.25-.59.41-.98.41h-.01c-.39 0-.73-.16-.99-.41l-3.37-3.36c-.25-.25-.41-.6-.41-.99 0-.77.63-1.4 1.4-1.4.39 0 .74.16.99.41l2.38 2.38 6.23-6.23a1.408 1.408 0 0 1 1.98 1.98"
    })
  }));
};